import { render, staticRenderFns } from "./thatch.vue?vue&type=template&id=74fd6603&"
import script from "./thatch.vue?vue&type=script&lang=js&"
export * from "./thatch.vue?vue&type=script&lang=js&"
import style0 from "./thatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports